import { render, staticRenderFns } from "./CrudSubmissionList.vue?vue&type=template&id=a1aed350&"
import script from "./CrudSubmissionList.vue?vue&type=script&lang=js&"
export * from "./CrudSubmissionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports